import { atom } from "jotai";
import type { ITranslationStatus } from "../queries/translation-query";

/**
 * Per-space translation status, populated once at the SpaceTree root and
 * consumed by every Node row to render its colored dot. Avoids 100+
 * react-query subscriptions, just one fetch + one atom read per row.
 */
export const translationStatusAtom = atom<ITranslationStatus | null>(
  null as ITranslationStatus | null,
);
